import { createAction } from 'Lib/reduxUtils';

import { GUEST_UNAUTHORIZED, LOGOUT_FAILURE, LOGOUT_SUCCESS } from 'Store/mfa/constants';
import {
  FETCH_PROFILE_SUCCESS,
  USER_DATA_SET_SUCCESS,
  USER_DATA_SET_SUCCESS_WITHOUT_REFRESH_RECS,
} from 'Store/profile/constants';
import { DELETE_ACCOUNT_SUCCESS } from 'Store/user/constants';

/**
 * Constants
 */
const resetActions = [
  DELETE_ACCOUNT_SUCCESS,
  LOGOUT_FAILURE,
  LOGOUT_SUCCESS,
  GUEST_UNAUTHORIZED,
] as const;
export const COMMON_RESET_ACTION_TYPE = new Set(resetActions);

export type CommonResetActionType = (typeof resetActions)[number];
export type CommonProfileActionType = (typeof profileActions)[number];

const profileActions = [
  FETCH_PROFILE_SUCCESS,
  USER_DATA_SET_SUCCESS,
  USER_DATA_SET_SUCCESS_WITHOUT_REFRESH_RECS,
] as const;

export const COMMON_PROFILE_ACTION_TYPE = new Set(profileActions);
export const getCommonResetAction = (type: string) =>
  COMMON_RESET_ACTION_TYPE.has(type as CommonResetActionType)
    ? (type as CommonResetActionType)
    : false;
export const getCommonProfileAction = (type: string) =>
  COMMON_PROFILE_ACTION_TYPE.has(type as CommonProfileActionType)
    ? (type as CommonProfileActionType)
    : false;

export const LAYOUT_DESKTOP = 'desktop';
export const LAYOUT_MOBILE = 'mobile';

export const STATE_INITIAL = 0;
export const STATE_LOADING = 1;
export const STATE_SUCCESS = 2;
export const STATE_ERROR = 3;

export const NETWORK_STATE_NETWORK_ERROR = 4;
export const POLLING_STATE_ERROR = 5;

export type LoadingStateType =
  | typeof STATE_INITIAL
  | typeof STATE_LOADING
  | typeof STATE_SUCCESS
  | typeof STATE_ERROR;

export type NetworkLoadingStateType =
  | LoadingStateType
  | typeof NETWORK_STATE_NETWORK_ERROR
  | typeof POLLING_STATE_ERROR;

/**
 * Action Types
 */
export const REMOVE_PHOTO = 'REMOVE_PHOTO'; // TODO, why this is in common
export const LAYOUT_CHANGED = 'LAYOUT_CHANGED';
export const BEGIN_SHORT_IDLE = 'BEGIN_SHORT_IDLE';
export const END_SHORT_IDLE = 'END_SHORT_IDLE';
export const BEGIN_LONG_IDLE = 'BEGIN_LONG_IDLE';
export const END_LONG_IDLE = 'END_LONG_IDLE';
export const LOGOUT = 'LOGOUT';

/**
 * Action Creators
 */
export const removePhoto = createAction(REMOVE_PHOTO, (userId: string, photoId: string) => ({
  userId,
  photoId,
}));
export const layoutChanged = createAction(LAYOUT_CHANGED, (layout: string) => ({ layout }));
export const beginShortIdle = createAction(BEGIN_SHORT_IDLE);
export const endShortIdle = createAction(END_SHORT_IDLE);
export const beginLongIdle = createAction(BEGIN_LONG_IDLE);
export const endLongIdle = createAction(END_LONG_IDLE);
export const logout = createAction(LOGOUT, (userTriggered: boolean = true) => ({ userTriggered }));
